import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnCitizenVideoStream } from './citizen-video-stream';

/**
 * Represents details of an incident associated with a video stream.
 */
export class SnCitizenIncidentDetails extends SnModel {
  /** ID for the incident. Stable across all updates. */
  @Expose({ name: 'id' })
  public id: string;

  /** Title of the incident. */
  @Expose({ name: 'title' })
  public title: string;

  /** Count of number of comments this incident has received. */
  @Expose({ name: 'comment_count' })
  public commentCount: number;

  /** Count of number of users who were notified about this incident. */
  @Expose({ name: 'notified_count' })
  public notifiedCount: number;

  /** Link to this incident in Citizen's ProtectOS Agency tool. */
  @Expose({ name: 'agency_link' })
  public agencyLink: string;

  /**
   * Category of the incident. Nullable.
   * Can be any of the following values:
   * Air Quality, Hurricane, Animal Related, Medical, Assault / Fight, Missing Person,
   * Auto IGL Incident, Missing Pet, Barricade, OnAir, Break In, Police Related, Community,
   * Product Recalls, COVID, Protest, Earthquake, Pursuit / Search, Election, Rescue, Fire,
   * Robbery / Theft, Fire / EMS Activity, Santa, Gun Related, Traffic Related, Harassment,
   * Transit, Hazardous Condition, Weapon, Helicopter, Weather, Wildfire.
   */
  @Expose({ name: 'category' })
  public category: string | null;

  /** GeoLocation of the incident. */
  @Expose({ name: 'geo_location' })
  public geoLocation: { longitude: number; latitude: number };

  /** Timestamp when the incident was last updated in ISO format, eg: 2025-01-31T03:03:30Z */
  @Expose({ name: 'update_at' })
  public updatedAt: string;

  public videos: SnCitizenVideoStream[] = [];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
